'use strict';

exports.__esModule = true;

var _styledBase = require('@emotion/styled-base');

var _styledBase2 = _interopRequireDefault(_styledBase);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return 'You have tried to stringify object returned from `css` function. It isn\'t supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).'; }

var AutofillSvgIcon = (0, _styledBase2.default)('button', {
	target: 'e109r7ue0',
	label: 'AutofillSvgIcon'
})(process.env.NODE_ENV === 'production' ? {
	name: '100k2ob',
	styles: 'display:flex;margin-left:auto;position:relative;right:-3px;border:none;outline:none;background:transparent;padding:0;z-index:111;svg{cursor:pointer;fill:#707070;height:17px;}&:hover{svg{fill:#1c1a1a;}}'
} : {
	name: '100k2ob',
	styles: 'display:flex;margin-left:auto;position:relative;right:-3px;border:none;outline:none;background:transparent;padding:0;z-index:111;svg{cursor:pointer;fill:#707070;height:17px;}&:hover{svg{fill:#1c1a1a;}}',
	map: '/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3NoYXJlZC9BdXRvZmlsbFN2Zy5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHcUMiLCJmaWxlIjoiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvc2hhcmVkL0F1dG9maWxsU3ZnLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcblxuY29uc3QgQXV0b2ZpbGxTdmdJY29uID0gc3R5bGVkLmJ1dHRvbmBcblx0ZGlzcGxheTogZmxleDtcblx0bWFyZ2luLWxlZnQ6IGF1dG87XG5cdHBvc2l0aW9uOiByZWxhdGl2ZTtcblx0cmlnaHQ6IC0zcHg7XG5cdGJvcmRlcjogbm9uZTtcblx0b3V0bGluZTogbm9uZTtcblx0YmFja2dyb3VuZDogdHJhbnNwYXJlbnQ7XG5cdHBhZGRpbmc6IDA7XG5cdHotaW5kZXg6IDExMTtcblxuXHRzdmcge1xuXHRcdGN1cnNvcjogcG9pbnRlcjtcblx0XHRmaWxsOiAjNzA3MDcwO1xuXHRcdGhlaWdodDogMTdweDtcblx0fVxuXG5cdCY6aG92ZXIge1xuXHRcdHN2ZyB7XG5cdFx0XHRmaWxsOiAjMWMxYTFhO1xuXHRcdH1cblx0fVxuYDtcblxuY29uc3QgU2VsZWN0QXJyb3dTdmcgPSBwcm9wcyA9PiAoXG5cdDxBdXRvZmlsbFN2Z0ljb24gey4uLnByb3BzfT5cblx0XHQ8c3ZnIHZpZXdCb3g9XCIwIDAgMjQgMjRcIj5cblx0XHRcdDxwYXRoIGQ9XCJNOCAxN3YtNy41ODZsOC4yOTMgOC4yOTNjMC4zOTEgMC4zOTEgMS4wMjQgMC4zOTEgMS40MTQgMHMwLjM5MS0xLjAyNCAwLTEuNDE0bC04LjI5My04LjI5M2g3LjU4NmMwLjU1MiAwIDEtMC40NDggMS0xcy0wLjQ0OC0xLTEtMWgtMTBjLTAuNTUyIDAtMSAwLjQ0OC0xIDF2MTBjMCAwLjU1MiAwLjQ0OCAxIDEgMXMxLTAuNDQ4IDEtMXpcIiAvPlxuXHRcdDwvc3ZnPlxuXHQ8L0F1dG9maWxsU3ZnSWNvbj5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IFNlbGVjdEFycm93U3ZnO1xuIl19 */',
	toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var SelectArrowSvg = function SelectArrowSvg(props) {
	return _react2.default.createElement(
		AutofillSvgIcon,
		props,
		_react2.default.createElement(
			'svg',
			{ viewBox: '0 0 24 24' },
			_react2.default.createElement('path', { d: 'M8 17v-7.586l8.293 8.293c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414l-8.293-8.293h7.586c0.552 0 1-0.448 1-1s-0.448-1-1-1h-10c-0.552 0-1 0.448-1 1v10c0 0.552 0.448 1 1 1s1-0.448 1-1z' })
		)
	);
};

exports.default = SelectArrowSvg;